import * as Sentry from '@sentry/react'

export const initSentry = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: 'https://7a880449681a6e30d39f0c7c2b13a063@o4508737768390656.ingest.de.sentry.io/4509446042484816',
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      integrations: [Sentry.browserTracingIntegration()],
      release: import.meta.env.PACKAGE_VERSION,
      tracesSampleRate: 0.5,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications.',
        'Plot code unknown',
        'Failed to fetch'
      ],
      environment: import.meta.env.VITE_API_HOST?.includes('-preprod') ? 'preprod' : 'production'
    })
  }
}
